import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';

import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';
import {Transporter} from '..';

@Injectable()
export class TransporterService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'TransporterService'; }

  protected get isAnonymous(): boolean { return false; }

  getTransporters(): Observable<SendBackResult<ArrayResponse<Transporter>>> {
    return this.get<ArrayResponse<Transporter>>(`/Transporters`);
  }
}
